import { createRouter, createWebHistory } from 'vue-router'
import LanguagesForm from '@/components/LanguagesForm.vue'
import SearchResults from '@/components/SearchResults.vue'

const routes = [
    {
        path:'/',name:'form',component:LanguagesForm,
    },
    {
        path:'/results',component:SearchResults
    }
]

const router = createRouter({
    history: createWebHistory(),
    routes
})

export default router